"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Button_1 = require("@material-ui/core/Button");
var Grid_1 = require("@material-ui/core/Grid");
var Link_1 = require("@material-ui/core/Link");
var TextField_1 = require("@material-ui/core/TextField");
var Typography_1 = require("@material-ui/core/Typography");
var withStyles_1 = require("@material-ui/styles/withStyles");
var Env_1 = require("src/Env");
var Forms_1 = require("src/Forms");
var Routing_1 = require("src/Routing");
var Snackbar_1 = require("src/Snackbar");
var Telemetry_1 = require("src/Telemetry");
var LogInForm = /** @class */ (function (_super) {
    __extends(LogInForm, _super);
    function LogInForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.emailInput = React.createRef();
        _this.passwordInput = React.createRef();
        /**
         * Prvent form from submitting as html form, and send to event handler
         */
        _this.onSubmit = function (event) {
            event.preventDefault();
            if (_this.props.status === 'waiting') {
                return;
            }
            var emailInput = _this.emailInput.current;
            var passwordInput = _this.passwordInput.current;
            /* istanbul ignore next */
            if (emailInput === null) {
                Telemetry_1.Sentry.logError(new Error('Email input not registerd to component'));
                return;
            }
            /* istanbul ignore next */
            if (passwordInput === null) {
                Telemetry_1.Sentry.logError(new Error('Password input not registerd to component'));
                return;
            }
            _this.props.onSubmit && _this.props.onSubmit({
                email: emailInput.value.trim(),
                password: passwordInput.value.trim(),
                aliasUUID: _this.props.aliasUUID
            });
        };
        return _this;
    }
    LogInForm.prototype.render = function () {
        var _a = this.props, classes = _a.classes, _b = _a.status, status = _b === void 0 ? 'ready' : _b, errorMessage = _a.errorMessage;
        var isDisabled = status === 'waiting';
        var isError = status === 'error';
        var textInputClassName = isError ? classes.errorInput : classes.primaryInput;
        return (React.createElement("form", { onSubmit: this.onSubmit },
            isError &&
                React.createElement(Snackbar_1.CustomSnackbar, { variant: "error", message: errorMessage || 'Email and Password Combination Failed' }),
            React.createElement(Grid_1.default, { container: true, direction: "column", className: classes.topGridItem },
                React.createElement(Grid_1.default, { item: true, className: classes.topGridItem },
                    React.createElement("img", { src: Env_1.ASSET_ROOT + "Logo-Signin.png", alt: "Rowan Technology" })),
                React.createElement(Grid_1.default, { item: true, className: classes.topGridItem },
                    React.createElement(TextField_1.default, { disabled: isDisabled, className: classes.fullWidth, InputProps: { className: textInputClassName }, variant: "filled", margin: "dense", label: "email", inputProps: { ref: this.emailInput }, name: "email" })),
                React.createElement(Grid_1.default, { item: true, className: classes.topGridItem },
                    React.createElement(TextField_1.default, { disabled: isDisabled, className: classes.fullWidth, InputProps: { className: textInputClassName }, variant: "filled", margin: "dense", label: "password", inputProps: { ref: this.passwordInput }, name: "password", type: "password" })),
                this.props.aliasUUID && (React.createElement(Grid_1.default, { item: true, className: classes.topGridItem },
                    React.createElement(Typography_1.default, { color: "textSecondary", variant: "caption" }, "Logging is as: " + this.props.aliasUUID))),
                React.createElement(Grid_1.default, { item: true, className: classes.topGridItem },
                    React.createElement(Button_1.default, { type: "submit", disabled: isDisabled, className: classes.fullWidth, variant: "contained", color: "primary", size: "large" }, "login")),
                React.createElement(Grid_1.default, { container: true, direction: "row", className: classes.topGridItem },
                    React.createElement(Grid_1.default, { className: classes.twoByChild, container: true, direction: "column" },
                        React.createElement(Grid_1.default, { item: true },
                            React.createElement(Link_1.default, { component: Routing_1.RouterLink('/resetPassword/'), variant: "body1", color: "textPrimary", underline: "none" }, "forgot password?")),
                        React.createElement(Grid_1.default, { item: true },
                            React.createElement(Link_1.default, { component: Routing_1.RouterLink('/resendConfirmation/'), variant: "body1", color: "textPrimary", underline: "none" }, "resend confirmation"))),
                    React.createElement(Grid_1.default, { className: classes.twoByChild, item: true },
                        React.createElement(Link_1.default, { component: Routing_1.RouterLink('/signUp/'), variant: "subtitle2", underline: "none" },
                            React.createElement(Button_1.default, { className: classes.fullWidth, variant: "outlined", color: "primary", size: "large" }, "sign up")))))));
    };
    return LogInForm;
}(React.Component));
exports.default = withStyles_1.default(Forms_1.styles)(LogInForm);
